"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateWaiterReducer = exports.createWaiterReducer = exports.fetchWaiterReducer = exports.updateWaiterSlice = exports.createWaiterSlice = exports.fetchSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const waiterAction_1 = require("./waiterAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.fetchSlice = (0, toolkit_1.createSlice)({
    name: "waiters/fetch",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(waiterAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        });
        builder.addCase(waiterAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(waiterAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.createWaiterSlice = (0, toolkit_1.createSlice)({
    name: "waiters/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(waiterAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        });
        builder.addCase(waiterAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(waiterAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.updateWaiterSlice = (0, toolkit_1.createSlice)({
    name: "waiters/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(waiterAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        });
        builder.addCase(waiterAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(waiterAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.fetchWaiterReducer = exports.fetchSlice.reducer;
exports.createWaiterReducer = exports.createWaiterSlice.reducer;
exports.updateWaiterReducer = exports.updateWaiterSlice.reducer;
